import { color } from "framer-motion";

const customStyles = {
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#f4f4f8",
      fontWeight: "bold",
      color:"#575757"
    }),
    option: (provided, state) => ({
      ...provided,
      fontWeight: "bold",
      backgroundColor: state.isSelected ? "#afd7d1" : "#f4f4f8",
      color: "#575757",
      borderBottom: "1px solid #ccc",
      display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      "&:last-child": {
        borderBottom: "none",
      },
      "&:hover": {
        backgroundColor: "#afd7d1",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontWeight:'bold',
       color:"#575757"
  }),
    MultiValue: (provided) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontWeight:'bold'
  }),
    placeholder: (provided) => ({
      ...provided,
      color: "#bdbdbd",
    }),
    input: (provided) => ({
      ...provided,
      fontWeight: "bold",
      color:"#575757"
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: "#dee2e6",
      boxShadow: "none",
      color:"#575757",
      "&:hover": {
        borderColor: "#dee2e6",
      },
    }),
  };
  export default customStyles;